import Contest from './Contest';

export default Contest;   